export function downloadBlob(blob: Blob | MediaSource, fileName: string) {
	return new Promise<void>((resolve, reject) => {
		try {
			const url = URL.createObjectURL(blob);
			const parent = document.body;
			const anchor = document.createElement("a");
			anchor.setAttribute("download", fileName);
			anchor.href = url;
			parent.append(anchor);
			anchor.click();
			parent.removeChild(anchor);

			setTimeout(() => {
				URL.revokeObjectURL(url);
				resolve();
			}, 250);
		} catch (ex) {
			reject(ex);
		}
	});
}
